<div class="tms-notif-bell-wrap">
  <button
    type="button"
    class="tms-notif-bell-btn"
    [attr.aria-label]="'notification.bellLabel' | t"
    (click)="onToggle($event)"
  >
    <i class="pi pi-bell" [class.tms-notif-bell-ring]="ringing"></i>
    <span class="tms-notif-badge" *ngIf="unreadCount > 0" [class.tms-notif-badge--pop]="badgePop"><ng-container
        *ngIf="unreadCount <= 99; else overNinetyNine"><app-live-number [value]="unreadCount" [maxDecimals]="0"
        [showDelta]="false"></app-live-number></ng-container><ng-template #overNinetyNine>{{ badgeLabel() }}</ng-template></span>
  </button>

  <!-- appendTo="body": this bell renders inside <header class="header">, which is position:sticky
       with a z-index and therefore a stacking context. Without escaping to body the panel is
       confined to it and anything with a higher z-index paints over the panel — the SpeedDial FAB
       sits at 9000 and does exactly that. Same fix as the Preferences drawer and the two confirm
       dialogs in header.component.html. -->
  <p-popover #op [dismissable]="true" appendTo="body" styleClass="tms-notif-panel">
    <div class="tms-notif-panel-inner">
      <div class="tms-notif-panel-header">
        <span class="tms-notif-panel-title">{{ 'notification.title' | t }}</span>
        <button
          type="button"
          class="tms-notif-mark-all"
          *ngIf="unreadCount > 0"
          (click)="markAllRead()"
        >
          {{ 'notification.markAllRead' | t }}
        </button>
      </div>

      <div class="tms-notif-list">
        <div class="tms-notif-empty" *ngIf="!loading && items.length === 0">
          <i class="pi pi-inbox"></i>
          <span>{{ 'notification.empty' | t }}</span>
        </div>

        <div
          *ngFor="let item of items"
          class="tms-notif-card"
          [class.tms-notif-card-unread]="item.status === 'UNREAD'"
          [class.tms-notif-card-high]="item.priority === 'HIGH'"
          (click)="onCardClick(item)"
        >
          <div class="tms-notif-card-dot" [attr.data-priority]="item.priority"></div>
          <div class="tms-notif-card-body">
            <div class="tms-notif-card-title">{{ item.title }}</div>
            <div class="tms-notif-card-text" *ngIf="item.body">{{ item.body }}</div>
            <!-- Recipient's own signup-chosen timezone, not the viewing device's clock — see
                 recipientTimezone's own note in notification.model.ts -->
            <div class="tms-notif-card-time">{{ item.createdAt | userDate:'short':item.recipientTimezone }}</div>

            <div class="tms-notif-card-actions" *ngIf="item.actionType === 'ACCEPT_DECLINE_INVITE' && item.status === 'UNREAD'">
              <button
                type="button"
                class="tms-notif-btn tms-notif-btn-accept"
                [disabled]="actingOnId === item.id"
                (click)="accept(item, $event)"
              >
                {{ 'notification.accept' | t }}
              </button>
              <button
                type="button"
                class="tms-notif-btn tms-notif-btn-decline"
                [disabled]="actingOnId === item.id"
                (click)="decline(item, $event)"
              >
                {{ 'notification.decline' | t }}
              </button>
            </div>

            <div class="tms-notif-resolution" *ngIf="item.actionType === 'ACCEPT_DECLINE_INVITE' && item.status === 'READ'">
              <span class="tms-notif-resolution-accepted" *ngIf="item.payload?.resolution === 'ACCEPTED'">
                <i class="pi pi-check-circle"></i> {{ 'notification.accepted' | t }}
                <span class="tms-notif-switch-hint" *ngIf="item.payload?.companyName">
                  — {{ 'notification.switchHint' | t }}
                </span>
              </span>
              <span class="tms-notif-resolution-declined" *ngIf="item.payload?.resolution === 'DECLINED'">
                <i class="pi pi-times-circle"></i> {{ 'notification.declined' | t }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="tms-notif-panel-footer">
        <button type="button" class="tms-notif-view-all" (click)="viewAll()">
          {{ 'notification.viewAll' | t }}
        </button>
      </div>
    </div>
  </p-popover>
</div>

<app-invite-accept-dialog [visible]="!!acceptItem" [busy]="actingOnId === acceptItem?.id" (confirmed)="confirmAccept()" (cancelled)="acceptItem = null"></app-invite-accept-dialog>
